import React, { FC, useCallback } from 'react';
import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import { AdfoxNew } from '../../adfox/adfoxNew';
import { ADFOX_NEW_MEDIA_CONSTANTS } from '../../adfox/constants';
import { isLoaderContext, parseAdfoxParams } from '../../../utils/adfox';
import { useBackgroundContext } from '../BackgroundProvider';

import styles from './CountrysideBrandBanner.css';

const POST_VIEW_ANALYTICS_DATA = {
  place: 'filters' as const,
  place__DEPRECATED: 'maintage',
  name__DEPRECATED: 'maintage_brand_filters',
};

type TAdFoxContext = IAdFoxBannerOnLoadData | { bgImageUrl?: string };

export const CountrysideBrandBanner: FC = () => {
  const { onAdfoxLoad, onAdfoxStub } = useBackgroundContext();

  const handleLoad = useCallback(
    (context: TAdFoxContext) => {
      const params = isLoaderContext(context as IAdFoxBannerOnLoadData)
        ? parseAdfoxParams(context as IAdFoxBannerOnLoadData)
        : (context as { bgImageUrl?: string });

      onAdfoxLoad(params?.bgImageUrl);
    },
    [onAdfoxLoad],
  );

  return (
    <div className={styles['container']}>
      <AdfoxNew
        constants={ADFOX_NEW_MEDIA_CONSTANTS}
        postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
        onLoad={handleLoad}
        onStub={onAdfoxStub}
      />
    </div>
  );
};
